import React, { useState } from 'react';
import { Image, View, StyleSheet, TouchableOpacity, Text, PixelRatio, ImageBackground } from 'react-native';
import { background, Icons } from '../../assets';
import LayoutWrapper from '../../components/LayoutWrapper/LayoutWrapper';
import { useNavigation } from '@react-navigation/native';
import { useGlobalState } from '../../shared/state';
import { I18N } from '../../shared/util';
import { Fonts, Styles } from '../../styles';


const CustomiseProducOrder: React.FC = (route): JSX.Element => {
    const { params } = route.route;
    const [language] = useGlobalState('language');
    const [customiseProductProcess, setCustomiseProductProcess] = useState<"WEIGHT" | "ACTIVITY">();
    const [weightValue, setWeightValue] = useState<Number | undefined>(undefined);
    const [activityValue, setActivityValue] = useState<String | undefined>(undefined);
    const [Colors] = useGlobalState('colors');

    const i18n = I18N(language);
    const navigation = useNavigation();
    const gtin = params.GTIN;
    const weightOption = [
        { category: i18n.t('CustomiseProduct.weight.upto65Kg'), value: 60 },
        { category: '65-75 Kg', value: 70 }, { category: '75-85 Kg', value: 80 },
        { category: '85-95 Kg', value: 90 }, { category: '95-110 Kg', value: 100 },
        { category: i18n.t('CustomiseProduct.weight.from110Kg'), value: 111 }
    ]
    const activityOption = [
        { category: i18n.t('CustomiseProduct.activity.mostlyStanding'), value: 'mostly-standing' },
        { category: i18n.t('CustomiseProduct.activity.mostlyWalking'), value: 'mostly-walking' },
        { category: i18n.t('CustomiseProduct.activity.mostlySitting'), value: 'mostly-sitting' },
    ]

    const customiseProductConfirm = () => {
        return (
            <View style={styles.content}>
                <View style={styles.iconsContainer}>
                    <Image style={styles.iconWrapper} source={Icons.customizeIcon} />
                </View>
                <Text style={[Fonts.textBold, Fonts.center]}>{i18n.t('CustomiseProduct.confirmCustomisation')}</Text>
                <View style={{ width: '100%', height: '35%', justifyContent: 'space-evenly' }}>
                    <TouchableOpacity style={Styles.submitButtonDark} onPress={() => setCustomiseProductProcess('WEIGHT')} >
                        <Text style={[styles.buttonText, Colors.white]}>{i18n.t('yes')}</Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={Styles.submitButtonLight} onPress={() => navigation.replace('Order', { GTIN: gtin })}>
                        <Text style={[styles.buttonText, Colors.black]}>{i18n.t('no')}</Text>
                    </TouchableOpacity>
                </View>
            </View>)
    }

    const selectWeight = () => {
        return (
            <View style={styles.selectionContent}>
                <View style={styles.headerWrapper}>
                    <Text style={Fonts.textHuge}>{i18n.t('weight')}</Text>
                    <View style={styles.selectioniconContainer}>
                        <Image style={styles.iconWrapper} source={Icons.balanceIcon} />
                    </View>
                </View>
                <View style={styles.weightcardWrapper}>
                    {weightOption.map((option: any, index: number) => (
                        <TouchableOpacity style={weightValue === option.value ? styles.weightoptionCardActive : styles.weightoptionCard} key={index} onPress={() => setWeightValue(option.value)}>
                            <Text style={weightValue === option.value ? styles.optionCardCaptionActive : styles.optionCardCaption}>{option.category}</Text>
                        </TouchableOpacity>))}
                </View>
                {!weightValue && <TouchableOpacity style={[Styles.submitButtonLight, { marginTop: 50 }]} onPress={() => setCustomiseProductProcess(undefined)}>
                    <Text style={[styles.buttonText, Colors.black]}>{i18n.t('back')}</Text>
                </TouchableOpacity>}
                {weightValue && <TouchableOpacity style={[Styles.submitButtonDark, { marginTop: 50 }]} onPress={() => setCustomiseProductProcess('ACTIVITY')} >
                    <Text style={[styles.buttonText, Colors.white]}>{i18n.t('next')}</Text>
                </TouchableOpacity>}
            </View >
        )
    }

    const selectActivity = () => {
        return (
            <View style={styles.selectionContent}>
                <View style={styles.headerWrapper}>
                    <Text style={Fonts.textHuge}>{i18n.t('activity')}</Text>
                    <View style={styles.selectioniconContainer}>
                        <Image style={styles.iconWrapper} source={Icons.activityIcon} />
                    </View>
                </View>
                <View style={styles.activitycardWrapper}>
                    {activityOption.map((option: any, index: number) => (
                        <TouchableOpacity style={activityValue === option.value ? styles.activityoptionCardActive : styles.activityoptionCard} key={index} onPress={() => setActivityValue(option.value)}>
                            <Text style={activityValue === option.value ? styles.optionCardCaptionActive : styles.optionCardCaption}>{option.category}</Text>
                        </TouchableOpacity>
                    ))}
                </View>
                {!activityValue && <TouchableOpacity style={Styles.submitButtonLight} onPress={() => [setCustomiseProductProcess('WEIGHT'), setWeightValue(undefined)]}>
                    <Text style={[styles.buttonText, Colors.black]}>{i18n.t('back')}</Text>
                </TouchableOpacity>}

                {activityValue && <TouchableOpacity style={Styles.submitButtonDark} onPress={() => navigation.replace('Order', { GTIN: gtin, weight: weightValue, activity: activityValue })} >
                    <Text style={[styles.buttonText, Colors.white]}>{i18n.t('next')}</Text>
                </TouchableOpacity>}
            </View >
        )
    }

    return (
        <ImageBackground source={background} style={Styles.backgroundImage} imageStyle={{ opacity: 0.4 }}>
            <LayoutWrapper showHeaderCloseButton showHeaderLogo showBackButton={false}>
                <View style={styles.container}>
                    <TouchableOpacity style={styles.closeButton} onPress={() => navigation.goBack(null)}>
                        <Image source={Icons.closeIconSquare} style={styles.iconContainer} />
                    </TouchableOpacity>
                    <View style={styles.subcontainer}>
                        <View style={styles.modalWrapper}>
                            {!customiseProductProcess && customiseProductConfirm()}
                            {customiseProductProcess === 'WEIGHT' && selectWeight()}
                            {customiseProductProcess === 'ACTIVITY' && selectActivity()}
                        </View>
                    </View>
                </View>
            </LayoutWrapper>
        </ImageBackground>
    );
};

export default CustomiseProducOrder;

const styles = StyleSheet.create({
    container: {
        width: '70%',
        height: '80%',
        alignSelf: 'center',
        justifyContent: 'center',
        marginTop: '2%',
        backgroundColor: 'white'
    },
    subcontainer: {
        width: '70%',
        height: '90%',
        alignSelf: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    modalWrapper: {
        width: '50%',
        height: '80%',
        flexDirection: 'column',
        alignItems: 'center',
        alignSelf: 'center',
    },
    closeButton: {
        width: '6%',
        height: '12%',
        position: 'absolute',
        right: -5,
        top: 0,
        zIndex: 10
    },
    iconContainer: {
        width: '100%',
        height: '100%',
        resizeMode: 'contain'
    },
    content: {
        width: '70%',
        height: '100%',
        justifyContent: 'space-around',
    },
    iconsContainer: {
        width: '50%',
        height: '25%',
        alignSelf: 'center'
    },
    iconWrapper: {
        width: '100%',
        height: '100%',
        resizeMode: 'contain',
        alignSelf: 'center',
    },
    button: {
        width: 150,
        height: 38,
        top: '5%',
        borderRadius: 17,
        borderColor: '#707070',
        borderWidth: 1,
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        backgroundColor: 'rgba(255, 255, 255, .5)'
    },
    buttonText: {
        ...Fonts.mRegular,
        ...Fonts.size12,
        ...Fonts.center,
        textTransform: 'uppercase'
    },
    selectionContent: {
        height: '100%',
        width: '100%',
        flexDirection: 'column',
        // marginTop: '30%',

        alignItems: 'center'
    },
    headerWrapper: {
        height: '20%',
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottomColor: '#cacaca',
        borderBottomWidth: 2 / PixelRatio.get(),
        paddingTop: '10%',
    },
    selectioniconContainer: {
        width: '80%',
        height: '100%',
        marginLeft: "30%",
        marginBottom: '1%',
        alignItems: 'flex-end'
    },
    weightcardWrapper: {
        width: '90%',
        height: '50%',
        justifyContent: 'space-between',
        flexDirection: 'row',
        flexWrap: 'wrap',
        paddingTop: '1%',
    },
    activitycardWrapper: {
        width: '90%',
        height: '60%',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        alignContent: 'center',
        flexDirection: 'column',
        flexWrap: 'wrap',
        paddingTop: '1%',
    },
    weightoptionCard: {
        width: '45%',
        height: '27%',
        borderRadius: 5,
        borderWidth: 0.5,
        borderColor: 'black',
        justifyContent: 'center',
        marginTop: '5%'
    },
    weightoptionCardActive: {
        width: '45%',
        height: '27%',
        borderRadius: 5,
        borderWidth: 0.5,
        borderColor: '#2bc6ff',
        justifyContent: 'center',
        marginTop: '5%'
    },
    activityoptionCard: {
        width: '70%',
        height: '20%',
        borderRadius: 5,
        borderWidth: 0.5,
        borderColor: 'black',
        justifyContent: 'center',
        marginTop: '5%'
    },
    activityoptionCardActive: {
        width: '70%',
        height: '20%',
        borderRadius: 5,
        borderWidth: 0.5,
        borderColor: '#2bc6ff',
        justifyContent: 'center',
        marginTop: '5%'
    },
    optionCardCaption: {
        fontFamily: 'Montserrat-Light',
        fontSize: 16,
        textAlign: 'center'
    },
    optionCardCaptionActive: {
        fontFamily: 'Montserrat-Light',
        fontSize: 16,
        textAlign: 'center',
        color: '#2bc6ff'
    },
    headerTitle: {
        fontFamily: 'Montserrat-Black',
        fontSize: 16,
        fontWeight: '600',
        textAlign: 'center',
        alignSelf: 'center',
    },

});